import {
    CONFIRMED_GET_SUBSCRIPTIONS
} from '../actions/Subscription/SubscriptionTypes';
const initialState = {
    subscriptions: [],
};

function SubscriptionReducer(state = initialState, actions) {
    if (actions.type === CONFIRMED_GET_SUBSCRIPTIONS) {
        return {
            ...state,
            subscriptions: actions.payload,
        };
    }
    return state;
}

export {SubscriptionReducer};